import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import ImageUpload from './ImageUpload';
import Avatar from '../Avatar';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

class OrganizationInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editNameDisabled: true,
            title: props.title,
        };
    }

    onEditName = () => {
        const { editNameDisabled, title } = this.state;

        if (editNameDisabled) {
            this.setState({ editNameDisabled: false });
        } else {
            if (title !== this.props.title) {
                this.props.onTitleChange(title);
            }
            this.setState({ editNameDisabled: true });
        }
    };

    onEnterField = e => {
        const { title } = this.state;

        if (e && e.key !== 'Enter') {
            return;
        }

        if (title !== this.props.title) {
            this.props.onTitleChange(title);
        }
        this.setState({ editNameDisabled: true });
    };

    onTitleChange = e => {
        this.setState({ title: e.target.value });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.title !== this.props.title) {
            this.setState({ title: this.props.title, editNameDisabled: true });
        }
    }

    render() {
        const { picture, isAdmin, onAvatarChange, classes } = this.props;
        const { editNameDisabled, title } = this.state;

        let image = '';
        if (isAdmin) {
            image = (
                <ImageUpload
                    avatarClassName={classes.picture}
                    picture={picture}
                    onAvatarChange={onAvatarChange}
                />
            );
        } else {
            image = (
                <Avatar.Large
                    src={picture}
                    alt="profile-picture"
                    className={classes.picture}
                />
            );
        }

        return (
            <div id="organization-info" className={classes.wrapper}>
                {image}
                <Typography
                    variant="headline"
                    className={
                        editNameDisabled ? classes.title : classes.hidden
                    }
                >
                    {title}
                </Typography>

                {!editNameDisabled && (
                    <div
                        className={classes.backdropStyle}
                        onClick={this.onEditName}
                    />
                )}

                {!editNameDisabled && (
                    <TextField
                        required
                        value={title}
                        onChange={this.onTitleChange}
                        onKeyPress={this.onEnterField}
                        variant="headline"
                        inputProps={{
                            className: classes.title,
                        }}
                    />
                )}
                {isAdmin && (
                    <Tooltip title="Rename organization">
                        <IconButton
                            className={classes.editNameButton}
                            onClick={this.onEditName}
                        >
                            <img alt="menu" src="/assets/edit_icon.svg" />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        );
    }
}

OrganizationInfo.propTypes = {
    title: PropTypes.node.isRequired,
    onAvatarChange: PropTypes.func.isRequired,
    onTitleChange: PropTypes.func.isRequired,
    picture: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
};

OrganizationInfo.defaultProps = {
    isAdmin: false,
};

const style = ({ palette, spacing, cover }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        color: palette.text.secondary,
        marginBottom: spacing.unit * 4,
    },
    picture: {
        width: '68px',
        height: '68px',
        marginRight: spacing.unit * 2,
    },
    title: {
        maxWidth: cover.titleWidth,
        fontSize: '22px',
        outline: 'none',
        zIndex: 256,
    },
    hidden: {
        visibility: 'hidden',
        width: 0,
    },
    editNameButton: {
        border: 'none',
        background: 'white',
        marginLeft: '12px',
        cursor: 'pointer',
        outline: 'none',
        zIndex: 256,
        '& img': {
            width: '15px',
            height: '15px',
        },
        '&:hover': {
            outline: 'none',
        },
    },
    backdropStyle: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 128,
    },
});

export default injectSheet(style)(OrganizationInfo);



// WEBPACK FOOTER //
// ./src/components/organizationInfo/OrganizationInfo.js